module.exports = __webpack_public_path__ + "static/media/doctor_login_mobile_image.01897f60.png";